import { render, staticRenderFns } from "./FindingList.vue?vue&type=template&id=f13bf71a&scoped=true"
import script from "./FindingList.vue?vue&type=script&lang=js"
export * from "./FindingList.vue?vue&type=script&lang=js"
import style0 from "./FindingList.vue?vue&type=style&index=0&id=f13bf71a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13bf71a",
  null
  
)

export default component.exports